"use strict";

require("moment/locale/en-gb");

require("moment/locale/es");

require("moment/locale/fr");

require("moment/locale/pt-br");

require("moment/locale/ru");